






















































































































import { Component, Vue } from "vue-property-decorator";
import { GeneralService } from "@/services/general-service";
import config from "@/services/api-config";
import router from "@/router";
import "@/styles/question.scss";

@Component({
  components: {},
  props: [
    "question",
    "listStart",
    "answer",
    "shouldDisable",
    "shouldDisplay",
    "type",
    "index",
  ],
})
export default class Answer extends Vue {
  question: any;
  answer: any;
  shouldDisable: any;
  shouldDisplay: any;
  listStart: number;
  checkedBind: string = "";
  type: string | null;
  index: number;
  private answers: any;
  private selected: string = "";
  private correct: any;
  private display: boolean = false;
  private answerAns: string = "alert-danger";
  private attempted: boolean = false;
  private service = new GeneralService();
  private htmlquestion = "";
  private isActive = true;
  private disable = false;
  private boards: any = [];
  private isQuestions = false;
  private showAnswer = false;

  checkAnswer(answer) {
    this.display = true;
    this.attempted = true;
    if (this.correct.AnswerId === answer.AnswerId) {
      this.selected = answer.AnswerId;
      this.answerAns = "alert-success";
    } else {
      this.selected = answer.AnswerId;
      this.answerAns = "alert-danger";
    }
    if (this.shouldDisable) this.disable = true;
  }

  checkOriginalAnswer(answer) {
    this.display = true;
    this.attempted = true;
    if (this.correct.AnswerId === answer.answerId) {
      this.selected = answer.answerId;
      this.answerAns = "alert-success";
    } else {
      this.selected = answer.answerId;
      this.answerAns = "alert-danger";
    }
    if (this.shouldDisable) this.disable = true;
  }

  created() {
    this.isQuestions =
      this.type === "shortquestions" || this.type === "longquestions";
    this.answers = JSON.parse(this.question.answers);

    if (this.isQuestions) {
      // For short/long questions, fullquestion is already valid HTML - use as-is
      // Only process through renderHTML if it contains LaTeX
      if (this.question.fullquestion && (this.question.fullquestion.indexOf('<lat>') !== -1 || this.question.fullquestion.indexOf('$') !== -1)) {
        this.question.fullquestion = config.renderHTML(this.question.fullquestion);
      }

      for (let answer of this.answers) {
        let imgContent = config.extractHTML(answer.FullAnswer);
        if (imgContent) {
          answer.FullAnswer = imgContent;
        } else if (answer.FullAnswer && (answer.FullAnswer.indexOf('<lat>') !== -1 || answer.FullAnswer.indexOf('$') !== -1)) {
          answer.FullAnswer = config.renderHTML(answer.FullAnswer);
        }
        // Otherwise keep FullAnswer as-is (it's already HTML)
      }

      this.boards = this.question.boards
        ? JSON.parse(this.question.boards)
        : null;
    } else {
      this.question.fullquestion = config.renderHTML(
        this.question.fullquestion
      );
      this.answers.sort(function (a, b) {
        return a.OrderNumber - b.OrderNumber;
      });

      for (let answer of this.answers) {
        answer.FullAnswer = config.renderHTML(answer.FullAnswer);
        // if (answer.AnswerId)
        //     answer.answerId = answer.AnswerId
      }

      this.correct = this.answers.find((e) => e.IsCorrect === 1);

      this.boards = this.question.boards
        ? JSON.parse(this.question.boards)
        : null;

      if (this.answer && this.answer.answerId !== "") {
        this.checkOriginalAnswer(this.answer);
      }
    }
  }
}
